import $ from "jquery";
import _ from "lodash";
import ScrollMagic from "scrollmagic";
import "debug.addIndicators";

import controller from "./scroll/controller";

(function() {
  let $page = $(".page");
  let $header = $(".header");
  let scenes = [];
  let offset = getOffset();

  function getOffset() {
    if ($("body").hasClass("admin-bar")) {
      if (window.innerWidth <= 600) {
        return 80 - 46;
      }
      if (window.innerWidth > 600 && window.innerWidth <= 783) {
        return 80 - 46 - 46;
      }
      if (window.innerWidth > 783) {
        return 80 - 32 - 32;
      }
    } else {
      return 80;
    }
  }

  const deleteScenes = () => {
    if (scenes.length) {
      scenes.forEach(function(scene) {
        scene.destroy(true);
      });
    }
  };

  const headerScene = () => {
    let scene = new ScrollMagic.Scene({
      // duration: $header.outerHeight(),
      offset: offset,
      triggerHook: 0,
      triggerElement: $page[0]
    })
      // .addIndicators()
      .addTo(controller)
      .on("enter", function(event) {
        if (event.scrollDirection == "REVERSE") return;
        $header.addClass("stuck");
        // enterTextScene(event, index, $this);
      })
      .on("leave", function(event) {
        if (event.scrollDirection == "FORWARD") return;
        $header.removeClass("stuck");
        // leaveTextScene(event, index, $this);
      });
    scenes.push(scene);
  };

  const init = () => {
    deleteScenes();
    headerScene();
  };

  init();
  $(window).on("resize", _.debounce(init, 100));
})();
